module.exports = __webpack_public_path__ + "static/media/records.2a16eeb6.svg";